export const PROJECT_LOOKUPS :{ [key:string] : string } = {
        projectLookup : 'api/projectlookups/projectlookup',
        hrConsultantLookup : 'api/projectlookups/hrConsultantLookup',
        hroLookup : 'api/projectlookups/hroLookup',
        
}

